<app-share-button></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id="105">
                    <h2>Easy Collect</h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button
                            class="btn share"><img src="./assets/share (5).svg" style="width: 30px;"
                                (click)="menues('share-button')" alt=""> </button> </a>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="105">


                    <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="5">
                        <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                            <iframe class="i-frame" src="https://www.youtube.com/embed/4o9XW0B-JaY?si=g6yaNdmeY1WRniMm"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen></iframe>
                        </div>
                    </div>
                    
                    <!--<div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'5')"
                (mouseout)="showpayment(false,'5')" id="100">
                    <h2>Workflow</h2>
                </div>
                
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')"
                (mouseout)="showpayment(false,'5')" id="100">
                    <img src="./assets/GIF/Creating Pay Button.gif" width="95%" height="95%"
                 alt="" style="border-radius: 10px;">
                 </div>-->
                    <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'2')"
                        (mouseout)="showpayment(false,'2')" id="53">
                        <h2>Use cases of Easy Collect </h2>
                    </div>

                    <div class="col-md-12  mt-2">
                        <div class="col-md-12 mt-4">
                            <label for="" class="mt-2">
                                <h3>Donations </h3>Easy Collect streamlines the process of collecting
                                donations for various causes. Merchants, such as non-profit
                                organizations or fundraising campaigns, can utilize the Easy Collect
                                profile to set up seamless and secure donation processes. This feature
                                allows donors to contribute easily with just a few clicks, leveraging
                                the convenience of online transactions.
                            </label>
                            <label for="" class="mt-4">
                                <h3>Registration Fee Collection </h3>For events, workshops, or
                                memberships that require registration fees, Easy Collect simplifies the
                                fee collection process. Merchants can set up customized payment
                                structures for different types of registrations, making it easy for
                                participants to pay online. This not only reduces the administrative
                                burden of handling physical payments but also enhances the overall
                                registration experience for participants.
                            </label>
                            <label for="" class="mt-4">
                                <h3>Real Estate </h3>In the real estate industry, Easy Collect
                                facilitates the collection of payments related to property transactions,
                                such as down payments, rent, or maintenance fees. Property owners or
                                real estate agencies can leverage this feature to offer tenants or
                                buyers a convenient and secure way to make payments.
                            </label>
                            <label for="" class="mt-4">
                                <h3>Insurance </h3>Insurance premiums and payments can be efficiently
                                managed through Easy Collect. Insurance companies can integrate this
                                feature into their online platforms to enable policyholders to pay
                                premiums seamlessly. This reduces the likelihood of payment delays and
                                ensures that policies remain active.
                            </label>

                        </div>
                        <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')"
                            (mouseout)="showpayment(false,'3')" id="54">
                            <h2>How to create an Easy collect profile:</h2>
                            <label for="" class="mt-4"><b>Step 1:</b> Sign up for a PayG
                                account. If you
                                already have an account, log in with your credentials.

                                <br><b>Step 2:</b> Navigate to the Pay Profile section and create a new
                                profile.

                                <br><b>Step 3:</b> Fill in the business details and payment details

                                <br><b>Step 4:</b> Configure the Payment Receipt settings.

                                <br><b>Step 5:</b> Adjust the Pay Profile configuration.

                                <br><b>Step 6:</b> Share your profile with your customers and begin
                                accepting payments.</label>
                        </div>
                        <div class="col-md-12 mt-4">
                            <h3>Sign in to your PayG account.</h3>
                        </div>
                        <div class="row">
                            <div class="col-md-12 mt-4">
                                <img src="./assets/login.png" width="100%" height="80%" alt="">
                            </div>
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="" class="mt-4">
                                <h3>On the left-hand side of the dashboard, there will
                                    be an option for
                                    “Pay Profile” Click on that and your Pay Profile dashboard will
                                    open.</h3>

                            </label>

                            <div class="row mt-4">
                                <img src="./assets/dashboard.png" alt="" width="80%" height="80%">
                            </div>
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">On the right-hand side of the Pay Profile
                                dashboard, click on
                                'Create New Pay Profile'.</label>

                            <img src="./assets/easy3.png" alt="" class="row mt-4" width="100%" height="80%">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">Among the two options “Smart collect” or “Easy
                                collect” select
                                “Easy Collect”.</label>

                            <img src="./assets/easy4.png" alt="" width="100%" height="80%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">In the next step, select your desired
                                template. In the “Custom
                                field,” you can create your own template as per your needs. It is fully
                                customizable. </label>

                            <img src="./assets/easy5.png" alt="" width="80%" height="80%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">Choose a template color as per your company’s
                                branding and
                                then fill in all of the essential details in the first step, "Setup
                                Profile." You can add as many fields as you need in this area</label>

                            <img src="./assets/easy6.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">Click on 'Add Field' to include fields in your
                                business
                                details and add terms and conditions according to your company or
                                organization's requirements</label>

                            <img src="./assets/easy7.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">Moving to the next stage, "Payment Receipt",
                                you can include
                                fields by selecting an input type based on what you need and how much
                                information you require from customers. Your customers will see these
                                fields, and they need to fill in their details.

                                For example, You need to take the Name, Email ID, Mobile number, Date of
                                Birth, and Gender of your customers so you can select Text fields,
                                Email, Mobile Number, Date Picker, and Radio Button respectively as
                                input fields. And you can keep the fields mandatory or not as per your
                                requirement. </label>

                            <img src="./assets/easy8.png" alt="" width="50%" height="40%" class="mt-4">
                            <br><img src="./assets/easy9.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">It will look like this after creating fields.
                            </label>
                            <br>
                            <img src="./assets/easy10.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">Then select “Amount Type”, how you want to
                                collect payment.
                            </label>
                            <img src="./assets/easy11.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for=""><b>Fixed amount:</b>If you wish to set the
                                price for a product
                                without giving the customer the option to choose the amount, select this
                                option. For instance, as an event organizer, if you're selling tickets
                                at a fixed price of ₹100 each and want customers to pay that specific
                                amount, you would choose the fixed price option. </label>
                            <label for="" class="mt-4"><b>Create Catalogue:</b> Create a
                                catalogue to
                                collect donations for various things </label>
                            <label for="" class="mt-4"><b>Create a Hierarchical
                                    catalog:</b> It is used
                                when you want to add inventories and different categories. </label>
                            <label for="" class="mt-4"><b>User Decides amount:</b> This
                                feature allows
                                your customers to choose the amount for the product or service. For
                                instance, it can be utilized for donations or similar scenarios.
                            </label>


                            <img src="./assets/easy12.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">It will be shown like this to your customers:
                            </label>
                            <br>
                            <img src="./assets/easy13.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">The next step is “Payment Receipt Settings”.
                                Select as per
                                your requirement and move to the next step.  </label>

                            <img src="./assets/easy14.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">In the "Pay Profile Settings" section, you
                                have options to set
                                up a custom URL. You can personalize the URL or opt for a randomly
                                generated one by selecting "Create a random URL". Additionally, you can
                                enable partial payment for your customers. Set the date and time for
                                when your profile should become active. You have the choice to include a
                                button for your profile and a QR code. Pick your preferences and then
                                click the "Next" button to create your profile.  </label>

                            <img src="./assets/easy15.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">You can copy the link and download the QR code
                                to send it to
                                your customers. Additionally, you can share it with your customers on
                                their mobile numbers or email</label>

                            <img src="./assets/easy16.png" alt="" width="50%" height="40%" class="mt-4"><br>
                            <img src="./assets/easy17.png" alt="" width="50%" height="40%" class="mt-4">
                        </div>
                        <div class="col-md-12 mt-4">
                            <label for="">After creating your profile, you'll be
                                directed to your
                                dashboard where you can view the profile you've just created. You can
                                check the profile's status, the total number of profiles you've created,
                                the number of views your profile has received, and the total revenue
                                generated from it</label>

                            <img src="./assets/easy18.png" alt="" width="100%" height="80%" class="mt-4">
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
        <div class="col-md-4 hide-tbl content2 ">
            <div class="card crd p-4">
                <div class="row">
                    <div class="col-md-12">
                        <h5>
                            Table of Contents:
                        </h5>

                    </div>
                    <div class="col-md-12 mt-3">
                        <a href="#105">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                        alt="">
                                    &nbsp;</div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="pdfHover" [ngClass]="{'video':colors=='1'}"
                                        (click)="color('1')">
                                        What is
                                        Easy Collect? </span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <!--<div class="col-md-12 mt-3">
                    <a href="#100">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/GIF/GIF.svg" class="tab-icon intro"
                                    alt="">
                                </div>
                            <div class="col-md-10 mt-1" >
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                                    >
                                    Workflow</span>
                            </div>
                        </div>
                    </a>
                </div>-->

                    <div class="col-md-12 mt-3">
                        <a href="#53">
                            <div class="row">
                                <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                        alt="">
                                    &nbsp;</div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                        (click)="color('2')"> Use Cases
                                        of Easy Collect </span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-12 mt-3">
                        <a href="#54">
                            <div class="row">
                                <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                        alt="">
                                    &nbsp;</div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                        (click)="color('3')">
                                        How to Create an Easy Collect Profile </span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-12 mt-3">
                        <a href="https://payg.in/customer/#/pay-profile/MTczMzkxNTkzOTMzNTky" target="_blank">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                                        alt="">
                                    &nbsp;</div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover2" [ngClass]="{'text':colors=='4'}"
                                        (click)="color('4')">
                                        Demo Profile for Seminar Registration</span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <!-- <div class="col-md-12 mt-3">
                        <a href="https://payg.in/customer/#/pay-profile/MTcwMjA3MTk4OQ" target="_blank">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                                        alt="">
                                    &nbsp;</div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover2" [ngClass]="{'text':colors=='4'}"
                                        (click)="color('4')">
                                        Demo profile for Real Estate</span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-12 mt-3">
                        <a href="https://payg.in/customer/#/pay-profile/MTcwODA4OTg1MQ" target="_blank">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                                        alt="">
                                    &nbsp;</div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover2" [ngClass]="{'text':colors=='4'}"
                                        (click)="color('4')">
                                        Demo profile for Collecting Insurance</span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-12 mt-3">
                        <a href="https://payg.in/customer/#/pay-profile/MTcwODM4MTI2NA" target="_blank">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                                        alt="">
                                    &nbsp;</div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover2" [ngClass]="{'text':colors=='4'}"
                                        (click)="color('4')">
                                        Demo profile for Seminar Registration</span>

                                </div>
                            </div>
                        </a>
                    </div> -->
                    <div class="col-md-12 mt-2">

                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-8">
                                <a href="./assets/PPT/Pay Profile Easy Collect new.pdf" target="_blank">
                                    <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                        (click)="color('4')">
                                        Easy Collect </span>
                                </a>
                            </div>
                            <div class="col-md-2">
                                <a href="./assets/PPT/Pay Profile Easy Collect new.pdf" download><img
                                    src="./assets/Downloadss.svg" alt="" width="100%"></a>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-9 hide ft-9">
            <hr>
            <div class=" row crd">
                <div class="col-md-8">
                    <a [routerLink]="['/pay-profile']"> <button class="btn btn-color" (click)="menues('Pay Profile')">
                            <img src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Pay Profile
                        </button></a>

                </div>
                <div class="col-md-4    ">
                    <a [routerLink]="['/smart-collect']"> <button class="btn btn-color"
                            (click)="menues('smart collect')">smart
                            collect
                            &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

                </div>

            </div>
        </div>
    </div>